import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ChartInfoIcon = (props) => {
	return (
		<SvgIcon {...props} viewBox="0 0 24 24">
			<path
				d="M10.2892 2.99414H7.95191C5.13014 2.99414 3.36011 4.99208 3.36011 7.81947V15.4488C3.36011 18.2762 5.12174 20.2742 7.95191 20.2742H16.0483C18.8794 20.2742 20.6401 18.2762 20.6401 15.4488V13.5794"
				stroke="#212121"
				strokeWidth="1.44"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.74927 16.5514L10.2712 13.877L13.9343 16.3038L16.407 13.877"
				stroke="#212121"
				strokeWidth="1.44"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.76609 10.4087V8.02404M6.88452 10.4087V6.62109"
				stroke="#212121"
				strokeWidth="1.44"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20.6402 6.8494C20.6402 4.72047 18.9142 2.99414 16.785 2.99414C14.6556 2.99414 12.9297 4.72047 12.9297 6.8494C12.9297 8.97877 14.6556 10.7047 16.785 10.7047C18.9142 10.7047 20.6402 8.97877 20.6402 6.8494Z"
				stroke="#212121"
				strokeWidth="1.44"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.6519 2.99609V6.55345C16.6519 6.79002 16.8437 6.98181 17.0802 6.98181H20.6376"
				stroke="#212121"
				strokeWidth="1.44"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</SvgIcon>
	);
};

export default ChartInfoIcon;
